import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLightningBoltOff: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLightningBoltOff"><Path d="M13.6973 16.5215L9.16406 22.3516L9.89844 15H4.45898L7.83496 10.6592L13.6973 16.5215Z" fill="currentColor"/><Path d="M20.2109 18.793L18.7969 20.207L3.79688 5.20703L5.21094 3.79297L20.2109 18.793Z" fill="currentColor"/><Path d="M14.1094 9H19.5488L16.1719 13.3398L10.3096 7.47754L14.8438 1.64844L14.1094 9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLightningBoltOff;
